export default {
  title: 'Nebula buds AI Chamada', // "Nebula buds AI通话" 翻译为葡萄牙语
  userID: 'ID do Usuário : ', // "用户ID : "
  hurryUp: 'Aguardando chamada da outra parte', // "等待对方呼叫"
  waitingCall: 'Aguardando chamada da outra parte nesta página, por favor não feche a página muito cedo.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Interruptor de Legendas', // "字幕开关"
  initWait: 'Aguardando inicialização', // "等待初始化"
  initSuccess: 'Inicialização concluída, aguardando chamada da outra parte. Por favor, não feche a página!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Chamada conectada', // "电话接通"
  callEnd: 'Chamada encerrada', // "通话结束"
  careful: 'Atenção : ', // "注意 : "
  wait: 'Componente de chamada pronto, aguardando chamada da outra parte', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Árabe', // "阿拉伯语"
    da: 'Dinamarquês', // "丹麦语"
    de: 'Alemão', // "德语"
    en: 'Inglês', // "英语"
    es: 'Espanhol', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'Francês', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonésio', // "印度尼西亚语"
    it: 'Italiano', // "意大利语"
    ja: 'Japonês', // "日文"
    ko: 'Coreano', // "韩语"
    ms: 'Malaio', // "马来语"
    no: 'Norueguês', // "挪威语"
    pt: 'Português', // "葡萄牙语"
    ru: 'Russo', // "俄语"
    sv: 'Sueco', // "瑞典语"
    th: 'Tailandês', // "泰语"
    tr: 'Turco', // "土耳其语"
    vi: 'Vietnamita', // "越南语"
    zh: 'Chinês' // "中文"
  }
}
